import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * Manifesto — "Por que a Coutin existe"
 * Sits right after the Hero as an anti-agency positioning statement.
 * Copy is intentionally short, punchy, and manifest-like.
 * CTA leads to /gestao-presencial (outsourced marketing squad).
 */
const Manifesto = () => {
  return (
    <section
      className="relative py-24 md:py-32 bg-[#0A0A0A] border-t border-white/5 overflow-hidden"
      data-testid="manifesto-section"
    >
      {/* Ambient */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(78,205,196,0.10)_0%,rgba(0,0,0,0)_60%)]" />
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10 max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <span className="text-xs tracking-[0.4em] uppercase font-bold text-[#4ECDC4] mb-6 inline-block">
            Por Que Existimos
          </span>

          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#F5F5F0] leading-[1.1] mb-10">
            Sua empresa não precisa de{' '}
            <span className="line-through text-[#666]">mais cinco fornecedores</span>.
            <br />
            Precisa de <span className="text-[#4ECDC4] italic font-light">uma só operação</span>.
          </h2>

          <p className="text-base md:text-lg text-[#D4D4D8] leading-relaxed font-light mb-6">
            A Coutin funciona como uma <strong className="text-[#F5F5F0]">extensão do seu marketing</strong>:
            planejamento, conteúdo, audiovisual, design, redes sociais, sites e campanhas — sob uma mesma operação.
          </p>

          <p className="text-base md:text-lg text-[#A1A1AA] leading-relaxed font-light italic mb-10">
            Presença, estratégia e execução. No mesmo lugar, com a mesma marca cuidando do começo ao fim.
          </p>

          {/* CTA to outsourced marketing page */}
          <Link
            to="/gestao-presencial"
            data-testid="manifesto-cta-gestao-presencial"
            className="group inline-flex items-center gap-2 border border-[#4ECDC4]/40 hover:border-[#4ECDC4] hover:bg-[#4ECDC4]/10 text-[#F5F5F0] font-bold uppercase tracking-[0.2em] text-xs md:text-sm px-6 py-3 rounded-lg transition-all duration-300"
          >
            <span>Conheça o modelo de marketing terceirizado</span>
            <ArrowRight className="w-4 h-4 text-[#4ECDC4] group-hover:translate-x-1 transition-transform duration-300" />
          </Link>

          {/* Divider */}
          <div className="mt-12 w-24 h-px bg-gradient-to-r from-transparent via-[#4ECDC4]/50 to-transparent mx-auto" />
        </motion.div>
      </div>
    </section>
  );
};

export default Manifesto;
